import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import CustomReportsDataGrid from '../../shared/customReports/customReportsDataGrid.component';
import withPillNavigation from '../withPillNavigation.decorator';
import Spinner from '../../shared/spinner.component';
import { getFiltersValues } from './helpers';
import { customReportPropTypes } from './propTypes';


const CustomReportsSetDataGrid = ({
  reports,
  customReportSetReports,
  reportSetId,
  isGridLoading,
  activePill,
  updatesParamsAndLocalStorage,
  queryParams,
  onGridReadyForExcelExport,
  disableLocalStorage,
}) => {
  const filtersValues = useMemo(() => getFiltersValues(reports), [reports]);

  return (
    <div className="ag-grid-full-page-with-secondary-menu">
      { isGridLoading ? <Spinner />
        : reports.map((report, index) => activePill === index.toString() && (<CustomReportsDataGrid
          updatesParamsAndLocalStorage={updatesParamsAndLocalStorage}
          columns={(report.columns) || []}
          rows={(report.rows) || []}
          types={(report.types) || {}}
          isGridLoading={isGridLoading}
          reportSetId={reportSetId}
          reportId={customReportSetReports?.[index]?.reportSetId}
          queryParams={queryParams}
          filtersValues={filtersValues}
          onGridReadyForExcelExport={onGridReadyForExcelExport}
          key={index}
          disableLocalStorage={disableLocalStorage}
        />))}
    </div>
  );
};

CustomReportsSetDataGrid.propTypes = {
  reports: PropTypes.arrayOf(PropTypes.shape({
    columns: PropTypes.arrayOf(PropTypes.string).isRequired,
    rows: PropTypes.arrayOf(
      PropTypes.objectOf(PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
      ]))
    ).isRequired,
    types: PropTypes.objectOf(PropTypes.number).isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired).isRequired,
  customReportSetReports: PropTypes.arrayOf(customReportPropTypes),
  activePill: PropTypes.string.isRequired,
  updatesParamsAndLocalStorage: PropTypes.bool,
  queryParams: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ])).isRequired,
  isGridLoading: PropTypes.bool,
  onGridReadyForExcelExport: PropTypes.func,
  reportSetId: PropTypes.string,
  disableLocalStorage: PropTypes.bool,
};

export default withPillNavigation(
  ({ reports }) => reports.map((report, index) => ({ label: report.pillName, type: `${index}` })),
  {}
)(CustomReportsSetDataGrid);
